import {View} from 'backbone';
import _template from 'dashboard/reports/edit-reports-dashboard.ejs';
import eventBus  from 'EventBus.js';
import constants from 'Constants.js';
import $ from "jquery";
import RestService from 'RestService.js';
import util from 'util/Util.js';

class EditReportsDashboardView extends View {

    className(){
        return 'EditReportsDashboardView';
    }

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;

        if (!this.model.get('dependenceList')) {
            this.model.set('dependenceList', [])
        }

        return this;
    }

    render() {
        this.$el.html(this.template(this.model.toJSON()));
        let _self = this;
        $('#recentEdits > ul > li').click(e => {
            _self.showReportDetails(e);
        });

        $('ul.select-list li').click(e => {
            _self.showReportsInfo(e);
        });

        return this;
    }

    showReportDetails(ev) {
        const reportId = ev.currentTarget.attributes["data-id"].value;
        eventBus.trigger(constants.EV_UPDATE_REPORT_DETAILS, reportId);
    }

    showReportsInfo(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        const reportId = ev.currentTarget.attributes["data-id"].value;
        const text = ev.target.innerHTML;

        if (reportId === 'all' || reportId === 'none'){
            return;
        }

        this.model.get('privateReports').map( ( r ) => {
            if ( r['@id'] === reportId) {
                r['@class'] = 'selected';
            }else{
                r['@class'] = '';
            }
        });

        let dependenceList = [];

        RestService.getReportDetails(reportId).then((reportDetailsResult) => {

            const reportDetailsData = reportDetailsResult.RESULT.RESPONSE.PrivateReportDetails;

            if (reportDetailsData['Dependencies']) {
                let tmpDependenceList = util.processArrayResult(reportDetailsData['Dependencies'], 'Dependency') || [];
                dependenceList = _.sortBy(tmpDependenceList,['@type', '@name']);
            }

            this.model.set('dependenceList', Object.assign([],dependenceList), {silent:true});
            this.render();

            $('#dropdownMenu1').text(text);

        }).catch((error) => {
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }
}

export default EditReportsDashboardView;